import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';
import { TableService }      from '../../app-lite/table/table.service';

import CeleroSettingsHtml from './celero.settings.html';

export function CeleroStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'CeleroSettingsCtrl',
    name       : 'app.celero-settings',
    templateUrl: CeleroSettingsHtml,
    url        : '/celero_settings',
    resolve    : {
      session  : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh(),
      settings : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations'),
      terminals: ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const cache = tableApi.getCacheForTable('posTerminal');

        return workshopAPI.get('/pos_terminals/tnp_terminal_list', [
          0,
          cache.paging.pageSize   || 5,
          cache.sorting.field     || 'pos_terminal_name',
          cache.sorting.direction || 'asc'
        ]);
      }
    }
  });
}